// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"7b3128f8","361":"3a2f9745","511":"5a3939dd","767":"7ee46077"}[chunkId] + ".chunk.js";
};